import React, { useState, useEffect, useRef } from "react";
import "./Index.css";
import api from "../../services/baseUrl";
import JataNegara from "../../assets/images/FEDERAL.png";
import { CircularProgress, Divider } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Search from "../../components/Search";
import { useLibrary } from "../../context/LibraryContext";
import PrintHtml from "../../components/PrintHtml";
import { excludedCustomAttributeId } from "./ExcludedCustomAttr";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HtmlWithPdfLinks from "../../components/HtmlWithPdfLinks";
import download from "downloadjs";
import HtmlWithGap from "./Gap";

export default function LawLibraryIndex() {
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  const documentId = queryParams.get("documentID");
  const [isLoading, setIsLoading] = useState(false);
  const [engOrBmId, setEngOrBmId] = useState();
  const contentRef = useRef();
  const { libraryId } = useLibrary();
  const [isBookmarked, setIsBookmarked] = useState(false);
  // const cookie = Cookies.get("user") || sessionStorage.getItem("user");
  const cookie = sessionStorage.getItem("user");
  const user = JSON.parse(cookie).user;
  const [pubHtml, setPubHtml] = useState("");
  const [bodyHtml, setBodyHtml] = useState("");
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await api.get(
          `/api/lawlibrary-documents/${documentId}`
        );
        const originalData = response.data;
        console.log(response.data.engOrBmId);
        setEngOrBmId(originalData.engOrBmId);

        // build a brand-new object, cloning only the arrays we’ll mutate
        const filteredData = {
          ...originalData,
          customAttributes: originalData.customAttributes.filter(
            (attr) => attr.value != null && attr.value !== ""
          ),
          subdocuments: originalData.subdocuments.filter(
            (sd) => sd.typeId !== 1
          ),
        };

        setData(filteredData);
        console.log(filteredData);

        const subDocuments = originalData.subdocuments;

        if (subDocuments.length === 1) {
          const subtitle = subDocuments[0].subTitle?.toLowerCase() || "";

          if (
            subtitle.startsWith("proclamation") ||
            subtitle.startsWith("appointment")
          ) {
            console.log(subDocuments[0].subTitle);

            const subResp = await api.get(
              `api/lawlibrary-documents/subdocument/${subDocuments[0].subdocumentID}`
            );
            setBodyHtml(subResp.data.currentSubdocument.bodyHtml);
          }

          const subdoc = subDocuments[0];
          setPubHtml(
            subdoc.bodyHtml
          );
        }
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    if (documentId) {
      fetchData();
    }
  }, [documentId]);

  useEffect(() => {
    const checkBookmark = async () => {
      const response = await api.get("/bookmark/check", {
        params: {
          username: user.userName,
          documentId,
          documentType: "LawLibrary",
        },
      });
      setIsBookmarked(response.data.bookmarked);
    };
    if (documentId) {
      checkBookmark();
    }
  }, [documentId, user.userName]);

    const fetchPdf = async (documentID) => {
      try {
        const response = await api.post(
          "/document/pdf/download/documentID",
          { documentID },
          {
            headers: {
              "Content-Type": "application/json",
            },
            responseType: "blob",
          }
        );

        const fileNameResponse = await api.post(
          "/document/pdf/getFileName/documentID",
          { documentID },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const fileName = fileNameResponse.data;

        const contentType = response.headers["content-type"];
        download(response.data, fileName.split("/").pop(), contentType);
      } catch (error) {
        console.error("Error downloading the PDF:", error);
      }
    };
  let prevPartPrefix = null;
  let prevDivisionPrefix = null;
  let prevSubDivisionPrefix = null;
  let prevChapter = null;
  let prevSubChapter = null;

  const isNewDivision = (division) => {
    if (!division) return null;

    const currentPrefix = division.split("-")[0];

    if (currentPrefix !== prevDivisionPrefix) {
      prevDivisionPrefix = currentPrefix;
      return division;
    } else {
      return null;
    }
  };

  const isNewSubDivision = (subDivision) => {
    if (!subDivision) return null;

    const currentPrefix = subDivision.split("-")[0];

    if (currentPrefix !== prevSubDivisionPrefix) {
      prevSubDivisionPrefix = currentPrefix;
      return subDivision;
    } else {
      return null;
    }
  };

  const isNewPart = (part) => {
    if (!part) return null;

    const currentPrefix = part.split("-")[0];

    if (currentPrefix !== prevPartPrefix) {
      prevPartPrefix = currentPrefix;
      return part;
    } else {
      return null;
    }
  };

  const isNewChapter = (chapter) => {
    if (chapter !== "" && chapter !== prevChapter) {
      prevChapter = chapter;
      return chapter;
    } else {
      return null;
    }
  };

  const isNewSubChapter = (subChapter) => {
    if (subChapter !== "" && subChapter !== prevSubChapter) {
      prevSubChapter = subChapter;
      return subChapter;
    } else {
      return null;
    }
  };

  const checkBookmark = async () => {
    const response = await api.get("/bookmark/check", {
      params: {
        username: user.userName,
        documentId,
        documentType: "LawLibrary",
      },
    });
    setIsBookmarked(response.data.bookmarked);
  };

  const handleBookmarkClick = async () => {
    if (isBookmarked) {
      const response = await api.delete("/bookmark/remove", {
        data: {
          username: user.userName,
          documentId,
          documentType: "LawLibrary",
        },
      });

      if (response.status === 200) {
        toast.success("Bookmark is removed.");
      }
    } else {
      const response = await api.post("/bookmark/add", {
        username: user.userName,
        documentId,
        documentType: "LawLibrary",
      });
      if (response.status === 200) {
        toast.success("Bookmark is added.");
      }
    }
    checkBookmark();
  };

  const handleSwitchToEngOrBmClick = (documentId) => {
    navigate(
      `/law-library/document?documentID=${documentId}`
    );
  };

  const handleNavigation = (subDocumentId) => {
    navigate(`/law-library/document?subdocumentId=${subDocumentId}`);
  };

  const handleSearch = ({ searchQuery, limit = 10, keyword, offset = 0 }) => {
    const globalPayload = {
      query: searchQuery,
      type: "content",
      modules: "lawlibrary",
      search: keyword,
      library: libraryId,
      limit,
      offset,
      documentID: documentId,
      documentName: data.title,
    };

    navigate("/law-library/search", { state: { globalPayload } });
  };

  const malayLibrary = [8, 9, 14, 13];

  return (
    <div style={{ marginBottom: "60px" }}>
      <div className="law-library-content-search-and-print">
        <Search
          onSearch={handleSearch}
          placeholder={"Enter keyword to search"}
        />
        <button
          className="print-law-library-btn"
          onClick={handleBookmarkClick}
          style={{ marginTop: "20px", padding: "5px" }}
        >
          {isBookmarked ? "Remove Bookmark" : "Add to Bookmark"}
        </button>
        {(data?.libraryID == 1 || data?.libraryID == 2) ? (
          <button
          className="print-law-library-btn"
          onClick={() => handleSwitchToEngOrBmClick(engOrBmId)}
          style={{ marginTop: "20px", padding: "5px" }}
        >
          Switch to BM
        </button>
        ) : ("") }
        {(data?.libraryID == 8 || data?.libraryID == 9) ? (
          <button
          className="print-law-library-btn"
          onClick={() => handleSwitchToEngOrBmClick(engOrBmId)}
          style={{ marginTop: "20px", padding: "5px" }}
        >
          Switch to Eng
        </button>
        ) : ("") }
        
        <PrintHtml contentRef={contentRef} />
      </div>
      {!isLoading ? (
        <div className="ll-container" ref={contentRef}>
          <div className="ll-index-logo">
            <img src={JataNegara} alt="jata-selangor" width={"7%"} />
            <p>LAWS OF MALAYSIA</p>
          </div>
          <Divider />
          <div className="ll-index-title">
            {/* <p>{data.no}</p> */}
            <p>{data?.no}</p>
            {/* <p>{data.title}</p> */}
            <p>{data?.title}</p>
          </div>
          <Divider />
          <div>
            {data?.customAttributes
              .filter(
                (customAttribute) =>
                  !excludedCustomAttributeId.includes(
                    customAttribute.customAttributeID
                  )
              )
              .map((customAttribute, index) => (
                <div key={index} className="attribute-row">
                  <div className="ll-attribute-name">
                    {customAttribute.name}
                  </div>
                  <div className="ll-attribute-value">
                    {customAttribute.value}
                  </div>
                </div>
              ))}
          </div>

          {bodyHtml !== "" && (
            <p
              dangerouslySetInnerHTML={{ __html: bodyHtml }}
              style={{ marginTop: "20px" }}
            ></p>
          )}
          {bodyHtml === "" && (
            <>
              {/* <div className="ll-arrangement" style={{ marginBottom: "20px" }}>
                <p className="ll-arrangement-title">
                  {malayLibrary.includes(libraryId) ? (
                    <>SUSUNAN SEKSYEN</>
                  ) : (
                    <>ARRANGEMENT OF SECTIONS</>
                  )}
                </p>
              </div> */}
                <HtmlWithGap
                  bodyHtml={pubHtml}
                  fetchPdf={fetchPdf}
                />
              <div className="ll-list">
                <ul className="ll-section-ul">
                  <li>
                    <p className="ll-section-title">{data?.title}</p>
                  </li>

                  {data?.subdocuments?.map((subDocument) => (
                    <li key={subDocument.subdocumentID}>
                      {<p>{isNewDivision(subDocument.division)}</p>}
                      {<p>{isNewSubDivision(subDocument.subDivision)}</p>}
                      {<p>{isNewPart(subDocument.part)}</p>}
                      {<p>{isNewChapter(subDocument.chapter)}</p>}
                      {<p>{isNewSubChapter(subDocument.subChapter)}</p>}
                      <p
                        className="section"
                        onClick={() => {
                          handleNavigation(subDocument?.subdocumentID);
                        }}
                      >
                        {subDocument.subTitle}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            </>
          )}
        </div>
      ) : (
        <div className="loading-container">
          <CircularProgress />
        </div>
      )}
      <ToastContainer />
    </div>
  );
}
